var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('container-wrapper', {
    attrs: {
      "designer": _vm.designer,
      "widget": _vm.widget,
      "parent-widget": _vm.parentWidget,
      "parent-list": _vm.parentList,
      "index-of-parent-list": _vm.indexOfParentList
    }
  }, [_c('el-row', {
    staticClass: "grid-container",
    class: [_vm.selected ? 'selected' : '', _vm.customClass],
    staticStyle: {
      "margin": "0"
    },
    attrs: {
      "gutter": _vm.widget.options.gutter
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.selectWidget(_vm.widget)
      }
    }
  }, [_vm._l((_vm.widget.cols), function(colWidget, colIdx) {
    return [_c('grid-col-widget', {
      key: colWidget.id,
      attrs: {
        "widget": colWidget,
        "designer": _vm.designer,
        "parent-list": _vm.widget.cols,
        "index-of-parent-list": colIdx,
        "parent-widget": _vm.widget,
        "col-height": _vm.widget.options.colHeight
      }
    })]
  })], 2)], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-484f4cf6","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-designer/form-widget/container-widget/grid-widget.vue
// module id = null
// module chunks = 